import { render, staticRenderFns } from "./PqrInicioTicket.vue?vue&type=template&id=0e87fbb8&scoped=true"
import script from "./PqrInicioTicket.vue?vue&type=script&lang=js"
export * from "./PqrInicioTicket.vue?vue&type=script&lang=js"
import style0 from "./PqrInicioTicket.vue?vue&type=style&index=0&id=0e87fbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e87fbb8",
  null
  
)

export default component.exports